'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const VolumeUpIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.5 9.00001C17 9.00001 18.2 10.3 18.2 12C18.2 13.7 17 15 15.5 15M15.5 18C18.3 18 21.2999 15.3 21.2999 12C21.2999 8.70001 18.3 6.00001 15.5 6.00001M7.39995 8.30001L6.79995 8.80001H3.99995C3.29995 8.80001 2.69995 9.40001 2.69995 10.1V14C2.69995 14.7 3.29995 15.3 3.99995 15.3H6.69995L7.29995 15.7L13.1 19.4V12V4.70001L7.39995 8.30001Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpVolumeUpIcon = forwardRef(VolumeUpIcon);

export { VpVolumeUpIcon as default };
